import React from 'react';
import { motion } from 'framer-motion';
import { useIntake } from '../../context/IntakeContext';
import { RadioGroup } from '../ui/RadioGroup';
import { MascotPanel } from '../ui/MascotPanel';
export function Step11Content() {
  const {
    data,
    updateData
  } = useIntake();
  return <motion.div initial={{
    opacity: 0,
    y: 20
  }} animate={{
    opacity: 1,
    y: 0
  }} exit={{
    opacity: 0,
    y: -20
  }} className="max-w-3xl mx-auto space-y-8" data-id="element-49" data-mp="283zccgcpyxtk">
      <MascotPanel message="Content is king! Een website heeft teksten en beeldmateriaal nodig. Hoe wilt u dit aanpakken?" data-id="element-50" data-mp="1fg39sv0gybov" />

      <div className="bg-white rounded-3xl shadow-sm border border-gray-100 p-8 space-y-8" data-id="element-51" data-mp="1kghk6jpjlxq2">
        <h2 className="text-2xl font-bold text-gray-900" data-id="element-52" data-mp="1pespch4w7k1y">
          Content & Beeldmateriaal
        </h2>

        <div data-id="element-53" data-mp="2vvnzzjeliy46">
          <label className="block text-sm font-semibold text-gray-900 mb-3" data-id="element-54" data-mp="30smu41y9f52d">
            Hoe wilt u de teksten voor de website regelen?
          </label>
          <RadioGroup columns={1} value={data.existingContent[0] || ''} onChange={val => updateData({
          existingContent: [val]
        })} options={[{
          value: 'write_all',
          label: 'Noord Digital schrijft alles (Aanbevolen)',
          description: 'Professionele, SEO-geoptimaliseerde teksten'
        }, {
          value: 'rewrite',
          label: 'Ik lever teksten aan, Noord Digital redigeert',
          description: 'Wij maken uw teksten web-klaar'
        }, {
          value: 'self',
          label: 'Ik schrijf en lever alle teksten zelf aan',
          description: 'U bent zelf verantwoordelijk voor de inhoud'
        }]} data-id="element-55" data-mp="2n80yfl9hdbkd" />
        </div>

        <div data-id="element-56" data-mp="1glniav11gtbh">
          <label className="block text-sm font-semibold text-gray-900 mb-3" data-id="element-57" data-mp="1gmyjcn33nmyw">
            Hoe zit het met fotografie en beeldmateriaal?
          </label>
          <RadioGroup columns={1} value={data.createContent[0] || ''} onChange={val => updateData({
          createContent: [val]
        })} options={[{
          value: 'have_photos',
          label: "Ik heb professionele foto's beschikbaar"
        }, {
          value: 'need_shoot',
          label: 'Ik wil graag een fotoshoot inplannen via Noord Digital'
        }, {
          value: 'stock',
          label: 'Gebruik (premium) stockfotografie'
        }]} data-id="element-58" data-mp="1bxe0k5jxcd1x" />

          <div className="mt-4 p-4 bg-blue-50 border border-blue-100 rounded-xl text-sm text-blue-800" data-id="element-59" data-mp="28m3hntnq91mu">
            <strong data-id="element-60" data-mp="2ddlj0itnx48c">Let op:</strong> Noord Digital neemt contact met u op over
            de specifieke wensen rondom fotografie en beeldmateriaal.
          </div>
        </div>

        <div className="pt-6 border-t border-gray-100" data-id="element-61" data-mp="3t4xjx6alzm45">
          <label className="block text-sm font-semibold text-gray-900 mb-3" data-id="element-62" data-mp="3t44imkuf5ote">
            Welke toon moet de website hebben?
          </label>
          <RadioGroup columns={2} value={data.toneOfVoice} onChange={val => updateData({
          toneOfVoice: val
        })} options={[{
          value: 'formal',
          label: 'Formeel (u-vorm, zakelijk)'
        }, {
          value: 'informal',
          label: 'Informeel (je-vorm, toegankelijk)'
        }, {
          value: 'mix',
          label: 'Mix (je-vorm maar wel professioneel)'
        }, {
          value: 'advise',
          label: 'Weet ik niet, adviseer mij'
        }]} data-id="element-63" data-mp="6pbft501sajc" />
        </div>
      </div>
    </motion.div>;
}